import { render, staticRenderFns } from "./InterazioneFarmaciView.vue?vue&type=template&id=1fd27cc9&scoped=true"
import script from "./InterazioneFarmaciView.vue?vue&type=script&lang=js"
export * from "./InterazioneFarmaciView.vue?vue&type=script&lang=js"
import style0 from "./InterazioneFarmaciView.vue?vue&type=style&index=0&id=1fd27cc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd27cc9",
  null
  
)

export default component.exports